import { ErrorMessage, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import {
  AddNamePDDInitialValues,
  NamePDDValidationSchema,
} from "./AddPDDMethods/FormikValidation";
import {
  StaffSubmitHandler,
  addModalInitialValuesHandler,
} from "./AddPDDMethods/AddNamePDDModalMethods";
import Select from "react-select";
import { AddOfficeProps } from "../../../../../../Type";
import TextError from "../../../../../../Components/FormikError/TextError";
import CustomButton from "../../../../../../Components/CustomElements/FormElements/CustomButton";

const AddNamePDD = ({ setIsOpen, modalEditData, refetch }: AddOfficeProps) => {
  const [addModalInitialValues, setAddModalInitialValues] = useState(
    AddNamePDDInitialValues
  );
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    addModalInitialValuesHandler(
      modalEditData,
      setAddModalInitialValues,
      setEditMode
    );
  }, [modalEditData]);

  return (
    <Formik
      validationSchema={NamePDDValidationSchema}
      initialValues={addModalInitialValues}
      enableReinitialize
      onSubmit={(values, actions) => {
        StaffSubmitHandler(
          values,
          actions,
          setIsOpen,
          refetch,
          editMode,
          modalEditData?.[0]?.id
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        isSubmitting,
        values,
        setFieldValue,
        setFieldError,
        errors,
      }) => {
        return (
          <div className="form-wrap">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col md={12}>
                  <Label>Crop</Label>
                  <Select
                    placeholder="Select Crop"
                    name="crop"
                    // options={gender_data}
                    // value={
                    //   gender_data?.filter(
                    //     (itm: any) => itm?.value === values?.gender
                    //   ) || ""
                    // }
                    // onChange={(e: any) => {
                    //   setFieldValue("gender", e?.value);
                    // }}
                    isLoading={false}
                    loadingMessage={() => "Fetching Crop"}
                    noOptionsMessage={() => "Crop appears here"}
                    isSearchable={true}
                    isClearable
                  />
                  <ErrorMessage name="crop" component={TextError} />
                </Col>
                <Col md={12}>
                  <Label>Name of PEST/DISEASE/DEFICIENCY</Label>
                  <Input
                    type="textarea"
                    onChange={handleChange}
                    name="name_pdd"
                    value={values?.name_pdd}
                    placeholder="NAME OF PEST/DISEASE/DEFICIENCY"
                  />
                  <ErrorMessage name="name_pdd" component={TextError} />
                </Col>
                <Col lg={12}>
                  <CustomButton
                    isLoading={isSubmitting}
                    label="Submit"
                    color="secondary"
                    className="sm submit-btn"
                  />
                </Col>
              </Row>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddNamePDD;
